import Vue from 'vue'
import Vuex from 'vuex'
import router from '../router'

Vue.use(Vuex)

export default new Vuex.Store({
	state: {
        ssUser: null,
        ssCrmTickets: [],
        ssCrmTicketCount: null,
        ssMatConsejerias: [],
        ssPriServiciosIngreso: [
            { IdServicio: 37, Descripcion: 'ADMINISTRACIÓN DE NEGOCIOS BANCARIOS Y FINANCIEROS', Iniciales: 'ANBF', Descripcion2: 'ANBF - ADMINISTRACIÓN DE NEGOCIOS BANCARIOS Y FINANCIEROS' },
            { IdServicio: 33, Descripcion: 'ADMINISTRACIÓN DE NEGOCIOS INTERNACIONALES', Iniciales: 'ANI', Descripcion2: 'ANI - ADMINISTRACIÓN DE NEGOCIOS INTERNACIONALES' },
            { IdServicio: 2, Descripcion: 'CONTABILIDAD', Iniciales: 'CON', Descripcion2: 'CON - CONTABILIDAD' },
            { IdServicio: 44, Descripcion: 'DESARROLLO DE SISTEMAS DE INFORMACIÓN', Iniciales: 'DSI', Descripcion2: 'DSI - DESARROLLO DE SISTEMAS DE INFORMACIÓN' },
            { IdServicio: 7, Descripcion: 'ADMINISTRACIÓN DE EMPRESAS', Iniciales: 'EADE', Descripcion2: 'EADE - ADMINISTRACIÓN DE EMPRESAS' },
            { IdServicio: 5, Descripcion: 'ADMINISTRACIÓN DE EMPRESAS TURÍSTICAS Y HOTELERAS', Iniciales: 'EADETHO', Descripcion2: 'EADETHO - ADMINISTRACIÓN DE EMPRESAS TURÍSTICAS Y HOTELERAS' },
            { IdServicio: 12, Descripcion: 'ADMINISTRACIÓN DE HOTELES Y RESTAURANTES', Iniciales: 'EAHORE', Descripcion2: 'EAHORE - ADMINISTRACIÓN DE HOTELES Y RESTAURANTES' },
            { IdServicio: 8, Descripcion: 'DIRECCIÓN Y ADMINISTRACIÓN DE NEGOCIOS', Iniciales: 'EDAN', Descripcion2: 'EDAN - DIRECCIÓN Y ADMINISTRACIÓN DE NEGOCIOS' },
            { IdServicio: 15, Descripcion: 'DIRECCIÓN CONTABLE Y FINANCIERA', Iniciales: 'EDICOFI', Descripcion2: 'EDICOFI - DIRECCIÓN CONTABLE Y FINANCIERA' },
            { IdServicio: 14, Descripcion: 'DIRECCIÓN DE HOTELERÍA Y HOSPITALIDAD', Iniciales: 'EDIHO', Descripcion2: 'EDIHO - DIRECCIÓN DE HOTELERÍA Y HOSPITALIDAD' },
            { IdServicio: 10, Descripcion: 'INGENIERÍA EN INTELIGENCIA ARTIFICIAL', Iniciales: 'EINIA', Descripcion2: 'EINIA - INGENIERÍA EN INTELIGENCIA ARTIFICIAL' },
            { IdServicio: 9, Descripcion: 'SISTEMAS CON INTELIGENCIA ARTIFICIAL', Iniciales: 'ESIA', Descripcion2: 'ESIA - SISTEMAS CON INTELIGENCIA ARTIFICIAL' },
            { IdServicio: 45, Descripcion: 'GASTRONOMÍA', Iniciales: 'GAS', Descripcion2: 'GAS - GASTRONOMÍA' },
            { IdServicio: 3, Descripcion: 'GUÍA OFICIAL DE TURISMO', Iniciales: 'GOT', Descripcion2: 'GOT - GUÍA OFICIAL DE TURISMO' },
            { IdServicio: 36, Descripcion: 'MARKETING', Iniciales: 'MAK', Descripcion2: 'MAK - MARKETING' },
        ],
	},
	mutations: {
		setUser(state, user) {
			state.ssUser = user
        },
        setCrmTickets(state, items) {
			state.ssCrmTickets = items
		},
        setCrmTicketCount(state, count) {
			state.ssCrmTicketCount = count
		},
        setMatConsejerias(state, items) {
			state.ssMatConsejerias = items
        },
	},
	actions: {
		saLogin({ commit }, user) {	
			commit('setUser', user)
			router.push('/')
        },
        saCrmTickets({ commit }, items) {	
			commit('setCrmTickets', items)
        },
        saCrmTicketCount({ commit }, items) {	
			commit('setCrmTicketCount', items)
        },
        saMatConsejerias({ commit }, items) {	
			commit('setMatConsejerias', items)
        },
        saAutoLogin({commit}){
            if(localStorage.getItem('ssUser')){
                let ssUser = JSON.parse(localStorage.getItem('ssUser'));
                commit('setUser', ssUser)
            }
        },
		saLogout({ commit }) {
            commit('setUser', null);

            var auth2 = null;

            try {
                auth2 = gapi.auth2.getAuthInstance();
                auth2.signOut().then(function () {
                    console.log('User signed out.');
                });
            } catch (error) {
                console.log(error);
            }            
            
            localStorage.clear();
			router.push('/Login')
		}
	},
	modules: {
	}
})
